import { useBoolean } from '@chakra-ui/hooks'
import { Popover, PopoverAnchor } from '@chakra-ui/popover'
import { Portal } from '@chakra-ui/portal'
import { IconProps } from '@chakra-ui/react'
import React, { MouseEventHandler } from 'react'
import { QuickActionButtonVariants } from '~/components/shared/componentStyles/QuickActionButton.style'
import { CustomTooltipContainer } from '~/components/shared/CustomTooltip/CustomTooltipContainer'
import {
  QuickActionButton,
  QuickActionButtonSizes,
} from '~/components/shared/QuickActionButton'

type PopoverActionButtonProps = {
  variant: QuickActionButtonVariants
  size?: QuickActionButtonSizes
  tooltipText: string
  icon: SVGComponent
  onButtonClick?: () => void
  iconProps?: IconProps
  popoverContents?: React.ReactNode
  isDisabled?: boolean
}

export const CustomTooltipActionButton = ({
  variant,
  size,
  tooltipText,
  icon,
  onButtonClick,
  iconProps,
  popoverContents,
}: PopoverActionButtonProps) => {
  const [menuOpen, setMenuOpen] = useBoolean(false)

  const buttonRef = React.useRef<HTMLButtonElement>(null)
  const containerRef = React.useRef<HTMLDivElement>(null)

  const handleButtonClick: MouseEventHandler<HTMLButtonElement> = (e) => {
    e.stopPropagation()
    onButtonClick?.()
  }

  const handleMouseEnter = () => {
    // Only show if we have contents to display
    if (!popoverContents) return
    setMenuOpen.on()
  }

  const handleMouseLeave = () => {
    setMenuOpen.off()
  }

  return (
    <Popover isOpen={menuOpen} placement="bottom-start">
      <PopoverAnchor>
        <QuickActionButton
          ref={buttonRef}
          actionIcon={icon}
          tooltipText={tooltipText}
          tooltipDisabled={menuOpen}
          variant={variant}
          size={size}
          onClick={handleButtonClick}
          iconProps={iconProps}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        />
      </PopoverAnchor>
      <Portal>
        {menuOpen && (
          <CustomTooltipContainer ref={containerRef}>
            {popoverContents}
          </CustomTooltipContainer>
        )}
      </Portal>
    </Popover>
  )
}
